export const formatPhoneDisplay = (value: string): string => {
    const digits = value.replace(/\D/g, '');
    const limitedDigits = digits.substring(0, 10);

    if (limitedDigits.length >= 6) {
        return `(${limitedDigits.substring(0, 3)}) ${limitedDigits.substring(
            3,
            6,
        )}-${limitedDigits.substring(6)}`;
    } else if (limitedDigits.length >= 3) {
        return `(${limitedDigits.substring(0, 3)}) ${limitedDigits.substring(3)}`;
    } else if (limitedDigits.length > 0) {
        return `(${limitedDigits}`;
    }

    return '';
};

export const extractPhoneDigits = (formattedValue: string): string => {
    return formattedValue.replace(/\D/g, '');
};
